import { Dispatch, FC, ReactElement, ReactNode, SetStateAction } from 'react'

import {
  Text,
  ContactList,
  TextAreaFieldInput,
  SimpleModal,
  Flex
} from '@sequencehq/core-components'
import {
  GreyGrey80,
  GreyGrey90,
  Primary13Regular,
  Primary13SemiBold
} from '@sequencehq/core-components'

type Props = {
  trigger: ReactElement
  title: string
  onSubmit: () => Promise<boolean>
  submitButtonText: string
  'data-testid'?: string
  contacts: Array<{ name?: string; email: string }>
  children?: ReactNode
}

export const SignatureModalTemplateRoot: FC<Props> = ({
  trigger,
  title,
  onSubmit,
  submitButtonText,
  'data-testid': dataTestId,
  contacts,
  children
}) => {
  return (
    <SimpleModal
      data-testid={dataTestId}
      variant="dialog"
      trigger={trigger}
      width="436px"
      title={title}
      onSubmit={onSubmit}
      submitButtonText={submitButtonText}
      submittingButtonText="Sending..."
      disableSubmitOnEnter
    >
      <Flex flexDir="column" gap="24px">
        <Text {...Primary13Regular} color={GreyGrey80} lineHeight="18px">
          All recipients will receive an email with a link to verify their email
          address and sign this quote.
        </Text>

        <Flex flexDir="column" gap="8px">
          <Text {...Primary13SemiBold} color={GreyGrey90}>
            Signers
          </Text>
          <ContactList>
            {contacts.map(({ name, email }, index) => (
              <ContactList.Row
                key={email}
                name={name}
                email={email}
                isLast={index === contacts.length - 1}
                data-testid="signatureModal.contactList"
              />
            ))}
          </ContactList>
        </Flex>

        {children}
      </Flex>
    </SimpleModal>
  )
}

const MessageField: FC<{
  message: string
  setMessage: Dispatch<SetStateAction<string>>
  'data-testid'?: string
}> = ({ message, setMessage, 'data-testid': dataTestId }) => {
  return (
    <Flex flexDir="column" gap="8px">
      <Text {...Primary13SemiBold} color={GreyGrey90}>
        Message (optional)
      </Text>
      <TextAreaFieldInput
        value={message}
        onChange={e => setMessage(e.target.value)}
        placeholder="Add message..."
        data-testid={dataTestId}
      />
    </Flex>
  )
}

export const SignatureModalTemplate = Object.assign(
  SignatureModalTemplateRoot,
  { MessageField }
)
